import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from '@mui/material';

const FinancialBudget = () => {
    const initialRows = [
        { id: 'iletisim', label: 'Yatırım Gereksinimi', values: [0, 0, 0, 0, 0] },
    ];

    const [rows, setRows] = useState(initialRows);

    const handleValueChange = (rowIndex, colIndex, value) => {
        const newValue = value === '' ? 0 : parseFloat(value) || 0;
        const newRows = [...rows];
        newRows[rowIndex].values[colIndex] = newValue;

        // Toplam satırları güncelle
        newRows.forEach((row, index) => {
            if (row.isTotal) {
                row.values = row.values.map((_, valIndex) => {
                    return calculateTotalForGroup(row.totalFrom, valIndex, newRows);
                });
            }
        });

        setRows(newRows);
    };

    const calculateTotalForGroup = (groupIds, colIndex, currentRows) => {
        return groupIds.reduce((total, id) => {
            const row = currentRows.find(r => r.id === id);
            return total + (row ? row.values[colIndex] : 0);
        }, 0);
    };

    const calculateRowTotal = (values) => {
        return values.reduce((acc, curr) => acc + curr, 0);
    };

    const calculateColumnTotal = (colIndex) => {
        return rows.reduce((acc, row) => acc + row.values[colIndex], 0);
    };


    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Kalemler</TableCell>
                        {[1, 2, 3, 4, 5].map((year) => (
                            <TableCell key={year} align="right">{`${year}.YIL`}</TableCell>
                        ))}
                        <TableCell align="right">TOPLAM</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIndex) => (
                        <TableRow
                            key={row.id}
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                backgroundColor: row.isTotal ? '#f5f5f5' : 'inherit'
                            }}
                        >
                            <TableCell
                                component="th"
                                scope="row"
                                sx={{ fontWeight: row.isTotal ? 'bold' : 'normal' }}
                            >
                                {row.label}
                            </TableCell>
                            {row.values.map((value, colIndex) => (
                                <TableCell key={colIndex} align="right">
                                    {row.isTotal ? (
                                        <strong>{value.toLocaleString()}</strong>
                                    ) : (
                                        <TextField
                                            type="number"
                                            value={value === 0 ? '' : value}
                                            onChange={(e) => handleValueChange(rowIndex, colIndex, e.target.value)}

                                            size="small"
                                            inputProps={{ style: { textAlign: 'right', maxWidth: '100px' } }}
                                        />
                                    )}
                                </TableCell>
                            ))}
                            <TableCell align="right">
                                <strong>{calculateRowTotal(row.values).toLocaleString()}</strong>
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell><strong>TOPLAM</strong></TableCell>
                        {[0, 1, 2, 3, 4].map((colIndex) => (
                            <TableCell key={colIndex} align="right">
                                <strong>{calculateColumnTotal(colIndex).toLocaleString()}</strong>
                            </TableCell>
                        ))}
                        <TableCell align="right">
                            <strong>
                                {rows
                                    .reduce((acc, row) => acc + calculateRowTotal(row.values), 0)
                                    .toLocaleString()}
                            </strong>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default FinancialBudget;